(ns minorodata.tables-metadata.api
  (:require [minorodata.tables-metadata.model :refer [->tables-metadata]]
            [mold-http.core :refer [reg-event-http]]))

(defn fetch-metadata-request [_ [params {:keys [on-success]}]]
  {:http-xhrio
   {:method    :GET
    :url       "/api/sink-tables"
    :cb-params {:params     params
                :on-success on-success}}})

(defn fetch-metadata-callback [_ [error
                                  {:keys [results] :as resp}
                                  {:keys [on-success]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch warehouse tables metadata"]}
    (do
      (when on-success (on-success resp))
      {:dispatch [:tables-metadata/update
                  (->tables-metadata {:tables results})]})))


(reg-event-http
 :tables-metadata.api/search
 fetch-metadata-request
 fetch-metadata-callback)
